import { Lightning, Router } from '@lightningjs/sdk'

import { getColor, grey50 } from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { AppConfig } from '../../services/appConfig'
import { CardItemModel, TvSpotlightModel } from '../../types/flo-experience'
import { getTopBadge } from '../../utils/cardUtils'
import { captureSessionData } from '../../utils/segmentAnalytics'
import { Buttons } from '../button/Buttons'
import TvBadge from '../TvBadge/TvBadge'

export interface TvBrowseLayoutSpotlightMetadata {
  spotlight_metadata?: TvSpotlightModel
}

export type SpotlightMetadataData = CardItemModel | TvBrowseLayoutSpotlightMetadata

export default class SpotlightMetadata extends Lightning.Component {
  static _template() {
    return {
      flex: {
        direction: 'column',
        justifyContent: 'flex-end',
      },
      collision: true,

      Metadata: {
        flex: { direction: 'row' },
        Badge: {
          type: TvBadge,
        },
        Details: {
          text: {
            text: '',
            textColor: getColor(grey50),
            fontFace: UniNeueRegular,
            fontSize: 28,
          },
        },
      },
      Title: {
        flexItem: { marginTop: 24 },
        text: {
          text: '',
          textColor: getColor(grey50),
          fontFace: UniNeueBold,
          fontSize: 48,
          maxLines: 2,
          maxLinesSuffix: '...',
          wordWrapWidth: 880,
          letterSpacing: 0.48,
        },
      },
    }
  }

  set data(v: SpotlightMetadataData) {
    this.renderSpotlightData(v)
  }

  get buttons() {
    return this.tag('Buttons') as Buttons
  }

  static _states() {
    return [
      class Buttons extends this {
        _getFocused() {
          return this.buttons
        }

        _handleLeft() {
          if (Router.getActivePage().widgets.menu.visible) {
            Router.focusWidget('Menu')
          } else {
            return false
          }
        }
      },
    ]
  }

  async $onApiCall(success: boolean) {
    if (success) {
      const params = Router.getActivePage().params
      void captureSessionData()

      // We need to get the updated favorite hub data which contains the
      // new action_buttons array after toggling favorites
      if (params?.url) {
        const newData = await AppConfig.shared.experienceApi.getFavoriteHub(params.url)
        this.buttons.buttons = newData?.spotlight?.action_buttons
        this._refocus()
      }
    }
  }

  updateBadge(status) {
    const badge = getTopBadge(status)

    if (badge) {
      this.patch({
        Metadata: {
          Badge: {
            data: badge,
          },
        },
      })
    }
  }

  renderSpotlightData(data: SpotlightMetadataData) {
    if (data?.spotlight_metadata?.action_buttons) {
      this._setState('Buttons')
    }

    this.patch({
      Metadata: {
        ...(data?.spotlight_metadata?.status_badges.length > 0 && {
          Badge: {
            flexItem: { marginRight: 24 },
            data: data?.spotlight_metadata?.status_badges[0],
          },
        }),
        Details: {
          text: {
            text: data?.spotlight_metadata?.details?.text ?? '',
          },
        },
      },
      Title: {
        text: {
          text: data?.spotlight_metadata?.title?.text ?? '',
        },
      },
      ...(data?.spotlight_metadata?.action_buttons && {
        Buttons: {
          type: Buttons,
          buttons: data?.spotlight_metadata?.action_buttons,
          flexItem: { marginTop: 40 },
        },
      }),
    })
  }
}
